const getters = {
  // sidebar: state => state.app.sidebar,
  // language: state => state.app.language,
  // size: state => state.app.size,
  // device: state => state.app.device,
  // visitedViews: state => state.tagsView.visitedViews,
  // cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  userInfo: state => state.user.userInfo,
  // status: state => state.user.status,
  auths: state => state.user.auths,
  // setting: state => state.user.setting,
  // permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  passwordToken: state => state.user.passwordToken,
  loginName: state => state.user.loginName,
  sessionId: state => state.user.sessionId,
  systemAuths: state => state.user.systemAuths
  // errorLogs: state => state.errorLog.logs
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js